import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="py-36 bg-gradient-to-br from-[#0A1F1F] to-[#0D9488]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
          프로젝트를 고민 중이신가요?
        </h2>
        <p className="text-lg text-gray-200 mb-12 max-w-2xl mx-auto">
          기술이 아닌 해결책을 제안드립니다.
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center justify-center px-10 h-14 bg-white text-[#0D9488] rounded-full font-medium text-base hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          문의하기
          <i className="ri-arrow-right-line ml-2"></i>
        </Link>
      </div>
    </section>
  );
}
